module.exports = __webpack_public_path__ + "media/components/engagement/screens/eng-note-a99284f94508768f22fb650099edae1b.svg";